module.exports = __webpack_public_path__ + "img/dealer-locator.da61506e.svg";